var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_1 = require("react-router");
var Component_1 = require("../../common/Component");
var URLS_1 = require("../../common/constants/URLS");
var Headings_1 = require("../../common/constants/Headings");
var stashable_1 = require("../../common/utils/stashable");
var CRM_1 = require("../../common/utils/CRM");
var react_transition_group_1 = require("react-transition-group");
var DynamicHOC_1 = require("../../common/new-components/DynamicHOC");
var GtmUtils_1 = require("../utils/GtmUtils");
var Vizury_1 = require("../../common/constants/Vizury");
var master_widget_1 = require("../../widget/master-widget");
var ACTIVE_URLS = [
    URLS_1.default.BIKE_LANDING,
    URLS_1.default.CAR_LANDING,
    URLS_1.default.TAXI_LANDING,
    URLS_1.default.LIFE_LANDING,
    URLS_1.default.HEALTH_INDEMNITY,
    URLS_1.default.TRAVEL_SINGLETRIP,
    URLS_1.default.ULIP_LANDING,
    URLS_1.default.HEALTH_SUPERTOPUP,
    URLS_1.default.TRAVEL_MULTITRIP,
];
var PASSIVE_URLS = [
    URLS_1.default.CAR_RESULTS,
    URLS_1.default.BIKE_RESULTS,
    URLS_1.default.BIKE_PROPOSAL,
    URLS_1.default.LIFE_RESULTS,
    URLS_1.default.LIFE_PROPOSAL,
    URLS_1.default.ULIP_RESULTS,
];
var PRODUCT_CONTENT_URLS = [
    URLS_1.default.BIKE_CMS,
    URLS_1.default.CAR_CMS,
    URLS_1.default.TAXI_CMS,
    URLS_1.default.LIFE_CMS,
    URLS_1.default.HEALTH_CMS,
    URLS_1.default.TRAVEL_CMS,
    URLS_1.default.ULIP_CMS,
];
var HEADINGS = [
    Headings_1.default.BIKE,
    Headings_1.default.CAR,
    Headings_1.default.CAR,
    Headings_1.default.TERM_LIFE,
    Headings_1.default.HEALTH,
    Headings_1.default.TRAVEL,
    Headings_1.default.ULIP,
    Headings_1.default.HEALTH_SUPER_TOPUP,
    Headings_1.default.TRAVEL_MULTITRIP,
];
var d;
var QUOTE_WIDGETS = [
    'bike-qf',
    'car-new',
    'commercial-car',
    'life-qf',
    'health-im',
    'travel-st',
    'ulip-qf',
];
var TAB_LABELS = [
    'Bike',
    'Car',
    'Taxi',
    'Term Life',
    'Health',
    'Travel',
    'Investment',
];
var PRODUCT_INDEX_LIMIT = TAB_LABELS.length - 1;
var TRANSITION_PROPS = {
    transitionName: 'slide-from-right',
    transitionEnterTimeout: 500,
    transitionLeaveTimeout: 300,
};
var WIDGET_REFERRER = '__widgetReferrer';
var PRESERVED_PARAMS = [];
var CMS_CONTAINER_ID = 'static-cms-content';
var SEO_SLUG;
var Widget = (function (_super) {
    __extends(Widget, _super);
    function Widget(props) {
        var _this = _super.call(this, props) || this;
        _this.crmCached = false;
        _this.cachePageContent = function () {
            _this.crmCached = true;
            setTimeout(_this.CRM.cache.bind(_this.CRM, _this.contentURLs), 3000);
        };
        _this.state = {
            index: _this.getQuoteWidgetIndex(),
        };
        if (!props.updateURL) {
            _this.lazyComponents = QUOTE_WIDGETS.map(function (widget) {
                var path = master_widget_1.PRODUCTS.filter(function (Product) { return Product.widget === widget; })[0]
                    .path;
                return DynamicHOC_1.DynamicHOC(path, props[widget]);
            });
        }
        _this.setupCRM(window.location.pathname, window.location.search);
        return _this;
    }
    Widget.prototype.componentWillMount = function () {
        stashable_1.default.init();
        window[WIDGET_REFERRER] = this.getCanonicalURL(this.getQuoteWidgetIndex());
    };
    Widget.prototype.componentDidMount = function () {
        if (SEO_SLUG === undefined)
            SEO_SLUG = window.location.pathname === '/' ? '?hp=1' : '';
    };
    Widget.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.location.pathname !== this.props.location.pathname) {
            this.setState({
                index: this.getQuoteWidgetIndex(),
            });
            window.closeRenewalPopup && window.closeRenewalPopup();
        }
    };
    Widget.prototype.componentWillUpdate = function (nextProps, nextState) {
        var URL = this.contentURLs[this.getProductIndex(nextState.index)];
        window.location.pathname !== '/' && URL && this.CRM.load(URL);
    };
    Widget.prototype.setupCRM = function (pathname, query) {
        if (query === void 0) { query = ''; }
        this.contentURLs =
            pathname === '/' || query.indexOf('hp=') !== -1
                ? PRODUCT_CONTENT_URLS
                : ACTIVE_URLS.slice(0, PRODUCT_INDEX_LIMIT);
        var callback = window['sectionScript']
            ? window['sectionScript']['reloadScript']
            : undefined;
        this.CRM = new CRM_1.default(CMS_CONTAINER_ID, null, callback);
    };
    Widget.prototype.getQuoteWidgetIndex = function () {
        for (var index in ACTIVE_URLS) {
            if (window.location.href.indexOf(ACTIVE_URLS[index]) !== -1)
                return +index;
        }
        if (this.props.router.isActive('/'))
            return 0;
    };
    Widget.prototype.getNonQuoteWidgetIndex = function () {
        for (var index in PASSIVE_URLS) {
            if (window.location.pathname.indexOf(PASSIVE_URLS[index]) !== -1)
                return +index;
        }
    };
    Widget.prototype.getProductIndex = function (index) {
        return index > PRODUCT_INDEX_LIMIT ? index - PRODUCT_INDEX_LIMIT : index;
    };
    Widget.prototype.getCanonicalURL = function (index) {
        return this.props.updateURL
            ? window.location.origin +
                (ACTIVE_URLS[this.getProductIndex(index)] || '')
            : window.location.href;
    };
    Widget.prototype.goTo = function (index) {
        if (index === (this.state.index || this.getQuoteWidgetIndex()))
            return;
        window[WIDGET_REFERRER] = this.getCanonicalURL(this.state.index);
        if (this.props.updateURL) {
            this.transitTo(ACTIVE_URLS[index] + SEO_SLUG, PRESERVED_PARAMS);
        }
        else {
            this.setState({ index: index });
            this.CRM.load(this.contentURLs[index]);
        }
        GtmUtils_1.default.gtm_push(Vizury_1.VIZ_QUOTE_REFRESH_AJAX, '', '', '', {});
    };
    Widget.prototype.updateContentVisibility = function (isNonQuoteWidget) {
        if (isNonQuoteWidget) {
            stashable_1.default.hide();
        }
        else {
            stashable_1.default.show();
        }
    };
    Widget.prototype.render = function () {
        var _this = this;
        var index = this.state.index;
        var _a = this.props, children = _a.children, updateURL = _a.updateURL;
        var isNonQuoteWidget = this.getNonQuoteWidgetIndex() !== undefined;
        var animationClass = isNonQuoteWidget ? 'fade-disappear' : 'fade-appear';
        var headerClassName = "h1 hero_header will-fade " + animationClass;
        var navWrapperClassName = "widget-nav will-fade " + animationClass;
        var LazyComp = !updateURL && !isNonQuoteWidget && this.lazyComponents[index];
        this.updateContentVisibility(isNonQuoteWidget);
        return (React.createElement("div", null,
            React.createElement("div", { className: headerClassName, hidden: isNonQuoteWidget },
                React.createElement(react_transition_group_1.CSSTransitionGroup, __assign({}, TRANSITION_PROPS),
                    React.createElement("span", { className: "hero_header__content", key: '_key_header' + index }, HEADINGS[index]))),
            React.createElement("ul", { hidden: isNonQuoteWidget, className: navWrapperClassName }, TAB_LABELS.map(function (label, i) { return (React.createElement("li", { key: i, className: index === i ? 'active' : '', onClick: _this.goTo.bind(_this, i), "data-hover": label }, label)); })),
            isNonQuoteWidget ? (children) : (React.createElement("div", { className: "widget_space" },
                React.createElement(react_transition_group_1.CSSTransitionGroup, __assign({}, TRANSITION_PROPS),
                    React.createElement("div", { key: index }, updateURL ? children : React.createElement(LazyComp, null)))))));
    };
    return Widget;
}(Component_1.default));
exports.default = react_router_1.withRouter(Widget);
